import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { DType, DTypeStatus } from '@grupo-constant/next-dtype/types';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { DTypeService } from '../dtype.service';
import { AuthService } from '../../auth/auth.service';
import { FuseConfigService } from '../../../../@fuse/services/config/config.service';
import { Form } from '../../form/form.types';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'dtype-editor-preview',
    templateUrl: 'dtype-editor-preview.component.html',
    styleUrls: ['./dtype-editor-preview.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeEditorPreviewComponent implements OnInit, OnDestroy {

    @Input() dtype: DType;
    @Input() status: DTypeStatus;

    dtypeForm: DTypeForm;
    object: any = {};
    showBOPreview = true;

    previewDeviceUrl: SafeUrl;
    ionicMode: 'md' | 'ios' = 'md';
    themeMode: 'auto' | 'light' | 'dark';

    private unsubscribeAll = new Subject<void>();

    constructor(
        private authService: AuthService,
        private domSanitizer: DomSanitizer,
        private dtypeService: DTypeService,
        private _fuseConfigService: FuseConfigService
    ) { }

    async ngOnInit() {
        this.dtypeForm = this.dtypeService.getDtypeFormFromDtype(this.dtype, { isUpdate: true });
        if (this.dtypeForm && this.isForm()) {
            const form = this.dtype as Form;
            this.showBOPreview = !form.editWithPreview;
            const config = await firstValueFrom(this._fuseConfigService.config$);
            this.themeMode = config?.scheme ? config.scheme : 'auto';
            this.generatePreviewUrl();
            this._fuseConfigService.config$
                .pipe(takeUntil(this.unsubscribeAll))
                .subscribe((conf) => {
                    if (conf?.scheme) {
                        if (this.themeMode !== conf.scheme) {
                            this.themeMode = conf.scheme;
                            this.generatePreviewUrl();
                        }
                    } else {
                        if (this.themeMode !== 'auto') {
                            this.themeMode = 'auto';
                            this.generatePreviewUrl();
                        }
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    reloadIframe() {
        const iframe = document.getElementById('deviceIframe') as HTMLIFrameElement;
        iframe.contentWindow.postMessage('reload', environment.previewUrl);
    }

    changeMode() {
        this.generatePreviewUrl();
    }

    isForm() {
        return this.dtypeForm.dType.uri.startsWith('form');
    }

    private async generatePreviewUrl() {
        if (!this.authService.accessTokenIsValid()) {
            try {
                await firstValueFrom(this.authService.doRefreshToken());
            } catch (error) {
                console.error(error);
            }
        }
        const accessToken = this.authService.accessToken;
        let url = `${environment.previewUrl}?uri=${this.dtypeForm.dType.uri}&status=${this.status}&ionic:mode=${this.ionicMode}&accessToken=${accessToken}`;
        if (this.themeMode !== 'auto') {
            url += `&theme=${this.themeMode}`;
        }
        this.previewDeviceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
